export default function Play() {
  return (
    <div>Play</div>
  );
}
